import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import { printdDate } from '../helper.js';
import View from './View';

class adminOrderView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Admin Order View Error Message';
  _message = 'Admin Order View Success Message';

  addHandlerOrderSearch(handler) {
    const searchForm = document.querySelector('.orderlist__search--form');
    if (!searchForm) return;

    searchForm.addEventListener('submit', e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const dataArr = [...new FormData(searchForm)];
      const data = Object.fromEntries(dataArr);
      
      handler(data);
    });
  }

  addHandlerOrderUpdate(handler) {
    const btnUpdate = document.querySelector('.order__admin--btn-update');

    const form = document.querySelector('.cart__payment--container');

    if (btnUpdate && form) {
      form.addEventListener('submit', e => {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (btnUpdate) btnUpdate.textContent = 'Updating...';
        const dataArr = [...new FormData(form)];
        const data = Object.fromEntries(dataArr);
        data.size = document.querySelector(
          '.product__size--btn-selected',
        ).dataset.size;

        handler(data, 'update');
      });
    }
  }

  addHandlerOrderSave(handler) {
    const btnSave = document.querySelector('.order__admin--btn-save');

    const form = document.querySelector('.cart__payment--container');

    if (btnSave && form) {
      form.addEventListener('submit', e => {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (btnSave) btnSave.textContent = 'Saving...';
        const dataArr = [...new FormData(form)];
        const data = Object.fromEntries(dataArr);
        data.size = document.querySelector(
          '.product__size--btn-selected',
        ).dataset.size;

        handler(data, 'save');
      });
    }
  }

  addHandlerOrderPay(handler) {
    const btnPay = document.querySelector('.order__admin--btn-pay');
    const form = document.querySelector('.cart__payment--container');
    if (btnPay && form) {
      btnPay.addEventListener('click', e => {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (btnPay) btnPay.textContent = 'Saving...';
        const dataArr = [...new FormData(form)];
        const data = Object.fromEntries(dataArr);
        data.size = document.querySelector(
          '.product__size--btn-selected',
        ).dataset.size;
        data.paymentOption = 'cod';

        handler(data, 'pay');
      });
    }
  }

  _generateMarkup() {
    const order = this._data;
    if (order.deliveryStatus === 'delivered') order.sizesAvailable = undefined;
    
    const requireIf = prop => (prop ? `required` : ``);

    let sizes =
      order.sizesAvailable && order.sizesAvailable.length > 0
        ? order.sizesAvailable.map(
            size => `

            <div class="product__size--button">
              <button type="button"
                class="product__size--btn ${size === String(order.size) ? `product__size--btn-selected` : ``} orderlist__size"
                data-size="${size}"
              >
                ${size}
              </button>
            </div>
              
              
              `,
          )
        : `<div class="product__size--button">
                <button type="button"
                  class="product__size--btn product__size--btn-selected"
                  data-size="${order.size}"
                >
                  ${order.size}
                </button>
              </div>`;

    if (order.sizesAvailable && order.sizesAvailable.length > 0)
      sizes = sizes.join('');

    const modifyOrder = () => `
            <h3 class="cart__payment--heading">Shipping Address</h3>

            ${order.shipAddress ? `<address class="paragraph address"><strong>${order.shipAddress}</strong></address>` : ``}

            <div class="label-input">
              <label for="${!order.shipAddress ? `` : `newAddress`}">New Shipping Address </label>
              <input
                type="checkbox"
                id="newAddress"
                name="newAddress"
                value="true"
                class="checkbox__new-ship-add"
                ${!order.shipAddress ? `checked` : ``}
                style="${!order.shipAddress ? `pointer-events: none` : ``}"
              />
            </div>

            
            <div class="cart__payment--lab-in">
              <label for="add-1">Address 1:</label>
              <input
                type="text"
                id="add-1"
                placeholder="your address"
                ${requireIf(!order.shipAddress)}                
                name="add1"
              />
            </div>
            <div class="cart__payment--lab-in">
              <label for="add-2">Address 2:</label>
              <input type="text" id="add-2" placeholder="your address" name="add2"/>
            </div>

            <div class="cart__payment--lab-in-2">
              <div class="cart__payment--lab-in">
                <label for="mobile">Mobile:</label>
                <input
                  type="tel"
                  id="mobile"
                  placeholder="9123456789"
                  maxlength="10"
                  minlength="10"
                  name="mobile"
                  ${requireIf(!order.shipAddress)}  
                />
              </div>
              <div class="cart__payment--lab-in">
                <label for="pin">Postal pin code:</label>
                <input
                  type="text"
                  id="pin"
                  placeholder="your pincode"
                  maxlength="6"
                  minlength="6"
                  name="pin"
                  ${requireIf(!order.shipAddress)}  
                />
              </div>
            </div>

            <div class="cart__payment--lab-in-2">
              <div class="cart__payment--lab-in">
                <label for="city">City/Dist:</label>
                <input type="text" id="city" name="dist" placeholder="Patna"  ${requireIf(!order.shipAddress)}   />
              </div>
              <div class="cart__payment--lab-in">
                <label for="state">State:</label>
                <input type="text" id="state" name="state" placeholder="Bihar"  ${requireIf(!order.shipAddress)}   />
              </div>
            </div>
    
    `;

    const updateOrder = () => `


              <label class="cart__payment--heading opacity--8">
                Shipping Address
              </label>
              ${
                order.shipAddress
                  ? `
              <address class="paragraph opacity--9 address">
                <strong>
                  ${order.shipAddress}
                </strong>
              </address>`
                  : ``
              }


              <label class="cart__payment--heading opacity--8">Mobile:</label>
              <p class="paragraph opacity--9">
                <strong> ${order.mobile} </strong>
              </p>

              <label class="cart__payment--heading opacity--8">Email:</label>
              <p class="paragraph opacity--9">
                <strong> ${order.email} </strong>
              </p>

              <label for="orderdt" class="cart__payment--heading opacity--8">
                Ordered on:
              </label>
              <p class="paragraph opacity--9">
                <strong><span class="orderlist__status">${order.orderedAt ? printdDate(order.orderedAt, true) : printdDate(order.createdAt, true)}</span> </strong>
              </p>

              <label for="status" class="cart__payment--heading opacity--8">
                Status:
              </label>
              ${
                order.status === 'paid'
                  ? `            <p class="paragraph opacity--9">
                <strong><span class="orderlist__status">Paid</span> </strong>
              </p>`
                  : `
              <select id="status" name="status">
                <option value=""></option>
                <option value="paid">Paid</option>
                <option value="created">Created</option>
              </select>
              <p class="paragraph opacity--9">
                <strong><span class="orderlist__status">${order.status}</span> </strong>
              </p>
              `
              }

              <!-- <p class="paragraph opacity--9">
                <strong><span class="orderlist__status">Paid</span> </strong>
                <strong><span class="orderlist__status">Created</span> </strong>
              </p> -->

              <label
                for="delivery-status"
                class="cart__payment--heading opacity--8"
              >
                Delivery Status:
              </label>
              ${
                order.deliveryStatus === 'delivered'
                  ? `
              <p class="paragraph opacity--9">
                <strong
                  ><span class="orderlist__status">Delivered</span>
                </strong>
              </p>
                `
                  : `
              <select id="delivery-status" name="deliveryStatus">
                <option value=""></option>
                <option value="payment due">Payment Due</option>
                <option value="order accepted">Order Accepted</option>
                <option value="in transit">In Transit</option>
                <option value="reached nearest hub">Reached Nearest Hub</option>
                <option value="delivered">Delivered</option>
              </select>

              <p class="paragraph opacity--9">
                <strong
                  ><span class="orderlist__status">${order.deliveryStatus}</span>
                </strong>
              </p>`
              }




              <label
                for="expected-delivery"
                class="cart__payment--heading opacity--8"
              >
              ${order.deliveryStatus === 'delivered' ? `Delivery Date:` : `Expected Delivery:`}
                
              </label>

              ${
                order.deliveryStatus === 'delivered'
                  ? `
              <p class="paragraph opacity--9">
                <strong> Delivered on: <span class="orderlist__status orderlist__status--delivered">${printdDate(order.deliveryDate, true)}</span>   </strong>
              </p>
                `
                  : `              <input
                type="date"
                id="expected-delivery"
                name="expectedDelivery"
              />
              <p class="paragraph opacity--9">
                <strong>Expected delivery on: <span class="orderlist__status"> ${order.expectedDelivery ? printdDate(order.expectedDelivery) : ``} </span>  </strong>
                
              </p>`
              }
    `;

    const getPrice = () => `    
              <div class="cart__price--container">
                <p class="cart__mrp--total cart__label-value">
                  <span class="cart__mrp--total-label cart__label"
                    >Total MRP:</span
                  ><span class="cart__mrp--total-value cart__value">₹${order.mrp}</span>
                </p>
                
                <p class="cart__discount--total cart__label-value">
                  <span class="cart__discount--total-label cart__label"
                    >Discount on MRP:</span
                  ><span class="cart__discount--total-value cart__value"
                    >${order.mrp - order.price > 0 ? `- ₹${order.mrp - order.price}` : `0`}</span
                  >
                </p>
                ${
                  order.platformFee
                    ? `<p class="cart__platformfee cart__label-value">
                  <span class="cart__platformfee-label cart__label"
                    >Platform Fee:</span
                  ><span class="cart__platformfee-value cart__value">₹${order.platformFee}</span>
                </p>`
                    : ``
                } 
                ${
                  order.tax
                    ? `<p class="cart__tax cart__label-value">
                  <span class="cart__tax-label cart__label">Tax:</span
                  ><span class="cart__tax-value cart__value">₹${order.tax}</span>
                </p>`
                    : ``
                }

                <p class="cart__price--total cart__label-value">
                  <span class="cart__price--total-label">Total Amount:</span
                  ><span class="cart__price--total-value"
                    ><strong>₹${Math.round(order.amount ? order.amount : order.price + +`${+(order.tax ? order.tax : 0)}` + +`${order.platformFee ? order.platformFee : 0}`)}</strong></span
                  >
                </p>
              </div>
    `;
    const modifyPrice = () => `    
              <div class="cart__price--container">
                <p class="cart__mrp--total cart__label-value">
                  <span class="cart__mrp--total-label cart__label"
                    >Total MRP (₹):</span
                  > 
                    <input
                      type="text"
                      value="${order.price}"
                      name="price"
                      class="cart__mrp--total-value cart__value cart__input"
                    />
                  
                </p>
              </div>
    `;

    
    return `
      <div class="order">
        <div class="order__head">
          <h2 class="order__heading">Order: #${order._id}</h2>
        </div>

        <div class="order__container">
          <form action="#" class="cart__payment--container">
            <!-- SHIPPING ADDRESS -->
            <div class="cart__payment--address">
                              <div class="cart__items--container-single">
                <ul class="cart__items">
                  <li class="cart__item">
                    <a href="#" class="link">
                      <div class="cart__item--img">
                        <img
                          src="${ASSETS}images/product/${order.imageCover}"
                          alt="${order.tag}"
                        />
                      </div>
                    </a>
                    <div class="cart__item--detail">
                      <div class="">
                        <h3 class="cart__item--title">
                          ${order.brand}
                        </h3>
                        <h4 class="cart__item--tag">${order.tag}</h4>
                        <div class="product__size--buttons">
                          ${sizes}
                        </div>
                      </div>

                      <div class="cart__item--price">
                        <span
                          class="cart__item--discounted-price order__quantity"
                          >QTY: ${order.quantity}</span
                        >
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              ${order.paymentMethod ? updateOrder() : modifyOrder()}
            </div>

            <!-- AMOUNT DETAILS -->
            <div class="cart__detail">
                ${order.paymentMethod ? getPrice() : modifyPrice()}
              <!-- PAYMENT OPTIONS -->
              ${
                order.paymentMethod
                  ? `
                <div class="cart__payment--options-container order__spec--detail order__spec--detail-admin">
                  <h3
                    class="product__spec--title cart__payment--method opacity--5"
                  >
                    Payment Method
                  </h3>
                  <ul class="cart__payment--options">
                    <li class="cart__payment--option">
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="${order.paymentMethod}"
                      id="payment"
                      class="cart__payment--option-radio"
                      checked
                    />
                      <label for="payment" class="margin__left--8px order__label"
                        >${order.paymentMethod ? order.paymentMethod.toUpperCase() : ``}</label
                      >
                    </li>
                  </ul>
                </div>
                
                `
                  : ``
              }


              ${
                order.paymentMethod === 'online'
                  ? `
              <div class="cart__payment--options-container order__spec--detail order__spec--detail-admin">
                <h3
                  class="product__spec--title cart__payment--method opacity--5"
                >
                  Payment ID
                </h3>
                <ul class="cart__payment--options">
                  <li class="cart__payment--option">
                    <label class="margin__left--8px order__label"
                      >${order.paymentId}</label
                    >
                  </li>
                </ul>
              </div>
                `
                  : ``
              }
              ${
                order.paymentMethod === 'cod'
                  ? `
                <div class="cart__payment--options-container order__spec--detail order__spec--detail-admin">
                <h3
                  class="product__spec--title cart__payment--method opacity--5"
                >
                  Paid Using
                </h3>
                <ul class="cart__payment--options">
                  <li class="cart__payment--option">
                  ${
                    order.paidIn
                      ? `
                   <label class="margin__left--8px order__label"
                      >${order.paidIn.toUpperCase()}</label
                    >
                <p class="paragraph opacity--9">
                  <strong><span class="orderlist__status">${printdDate(order.paidOn, true)}</span> </strong>
                </p>
                    `
                      : `
              <select id="paidIn" name="paidIn">
                <option value=""></option>
                <option value="cash">Cash</option>
                <option value="upi">Upi</option>
                <option value="card">Card</option>
              </select>
              <p class="paragraph opacity--9">
                <strong><span class="orderlist__status">Payment due</span> </strong>
              </p>
                    `
                  }
                    
                  </li>
                </ul>
              </div>
                `
                  : ``
              }
                          <!-- CTA -->
            ${
              order.deliveryStatus === 'delivered'
                ? ``
                : `
              <div class="cart__cta--container">
                <div class="cart__cta">
                  <button type="submit"
                    class="btn btn--cart cart__cta--btn  order__admin--btn-${order.paymentMethod ? `update` : `save`}"
                  >
                   ${order.paymentMethod ? `Update` : `Save`} 
                  </button>
                </div>

                ${
                  !order.paymentMethod
                    ? `
                <div class="cart__cta">
                  <button type="submit"
                    class="btn btn--cart cart__cta--btn  order__admin--btn-pay"
                  >
                   Save & Pay
                  </button>
                </div>
                  
                  `
                    : ``
                }


              </div>
              ${
                order.paymentMethod
                  ? ``
                  : `
              <p class="paragraph opacity--9">Order created at:<br>
                <strong><span class="orderlist__status">${printdDate(order.orderedAt ? order.orderedAt : order.createdAt, true)}</span> </strong>
              </p>
                
                `
              }

              `
            }

            </div>
          </form>
        </div>

        <!-- MANAGING orderlist ADDRESS AND PAYMENT -->
      </div>

    `;
  }
}

export default new adminOrderView();
